export default "__VITE_ASSET__BRGyCFHT__"